"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _APICommands = require("../constants/APICommands");
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _ApiConstants = _interopRequireDefault(require("../constants/ApiConstants"));
var _ViewMode = require("../constants/ViewMode");
var _ErrorUtils = require("../util/ErrorUtils");
var _Deferred = _interopRequireDefault(require("../util/Deferred"));
var _AppConstants = _interopRequireDefault(require("../constants/AppConstants"));
var _CallbackTypes = _interopRequireWildcard(require("../constants/CallbackTypes"));
var _EditUtil = _interopRequireWildcard(require("../util/EditUtil"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
class AppCommands {
  constructor() {
    this._apiCommands = {
      [_APICommands.AppAPICommands.CLOSE_PDF_VIEWER]: {
        action: this._closePDFViewer.bind(this)
      },
      [_APICommands.AppAPICommands.ENTER_FULL_SCREEN]: {
        action: this._enterFullScreen.bind(this)
      },
      [_APICommands.AppAPICommands.EXIT_FULL_SCREEN]: {
        action: this._exitFullScreen.bind(this)
      },
      [_APICommands.AppAPICommands.SET_HEIGHT_IN_VIEW]: {
        validator: this._heightInViewDataValidator.bind(this),
        action: this._setHeightInView.bind(this)
      },
      [_APICommands.AppAPICommands.TOGGLE_COMMENTING]: {
        action: this._toggleCommenting.bind(this)
      },
      [_APICommands.AppAPICommands.SET_LB_EXIT_PDF_VIEWER_TYPE]: {
        validator: this._validateExitPDFViewerType.bind(this),
        action: this._setExitPDFViewerType.bind(this)
      },
      [_APICommands.AppAPICommands.ENTER_EDIT_MODE]: {
        action: this._openEditMode.bind(this)
      },
      [_APICommands.AppAPICommands.UPDATE_EDIT_ENABLED]: {
        action: this._updateEditEnabled.bind(this)
      },
      [_APICommands.AppAPICommands.CLOSE_EDIT_MODE]: {
        action: this._closeEditMode.bind(this)
      },
      [_APICommands.AppAPICommands.GET_TOOLSBOARD_CONFIG]: {
        action: this._getToolsboardConfig.bind(this)
      },
      [_APICommands.AppAPICommands.TOGGLE_SPINNER]: {
        action: this._toggleSpinner.bind(this)
      },
      [_APICommands.AppAPICommands.START_POLLING]: {
        action: this._startPolling.bind(this)
      },
      [_APICommands.AppAPICommands.CLEAR_COMMAND_STACK]: {
        action: this._resetCommandStack.bind(this)
      },
      [_APICommands.AppAPICommands.ANNOTATION_MODE_END]: {
        action: this._endAnnotationMode.bind(this)
      },
      [_APICommands.AppAPICommands.UNDO_LAST_CHANGE]: {
        action: this._undoLastComment.bind(this)
      }
    };
  }
  static getClassName() {
    return "AppCommands";
  }

  /**
   * @method
   * @description
   * execute the commands related to app
   *
   * @param data - executable command
   */
  executeCommand(data) {
    const invalidError = this._validateCommand(data);
    if (invalidError) return Promise.reject(invalidError);
    return this._apiCommands[data.command].action.call(this, data.commandData);
  }

  /**
   * @method
   * @description
   * validate the commands whether it is allowed or not.
   *
   * @param data - command for validation
   *
   * @return Return undefined if it is valid
   */
  _validateCommand(data) {
    if (this._apiCommands[data.command].validator) {
      return this._apiCommands[data.command].validator(data);
    }
    return undefined;
  }
  _heightInViewDataValidator(data) {
    const {
      command,
      commandData
    } = data;
    let err;
    if (!commandData || !commandData.winHeight) {
      // Limited check intentionally
      err = (0, _ErrorUtils.commandError)(_ApiConstants.default.API_RESPONSE.INVALID_INPUT, `Invalid data provided for command ${command}`);
    }
    return err;
  }

  /**
   * @method
   * @description
   * Update the height for InLine View
   *
   * @param data - height of page view
   *
   * @return Return promise which resolve if successful
   */
  _setHeightInView(data) {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    if (appStore.isInLinePreset) {
      appStore.setHeightInView(data);
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }

  /**
   * @method
   * @description
   * Switched to full screen view mode
   *
   * @return Return promise which resolve true
   */
  _enterFullScreen() {
    _ServiceRegistry.default.getService("AppStore").setInFullScreen(true);
    return Promise.resolve(true);
  }

  /**
   * @method
   * @description
   * Exit from full screen view mode
   *
   * @return Return promise which resolve true
   */
  _exitFullScreen() {
    _ServiceRegistry.default.getService("AppStore").setInFullScreen(false);
    return Promise.resolve(true);
  }

  /**
   * @method
   * @description
   * Exit from the pdf viewer mode.
   *
   * @return Return promise which resolve true
   */
  _closePDFViewer() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    if (appStore.isLBPreset) {
      _ServiceRegistry.default.getService("EmbedModeService").LBExitPDFViewer();
      return Promise.resolve(true);
    }
    _ServiceRegistry.default.getService("CommentsApi").removeCommentsEventListeners();
    // In case of other embed mode, just call close PDF Viewer
    _ServiceRegistry.default.getService("EmbedModeService").unMountApp();
    return Promise.resolve(true);
  }
  _toggleCommenting(bool) {
    return _ServiceRegistry.default.getService("CommentsApi").toggleCommenting(bool, {
      enableCommentsPanel: true
    });
  }
  _validateExitPDFViewerType(data) {
    const {
      command,
      commandData
    } = data;
    let err;
    if (commandData !== _ViewMode.LightBoxExitPDFViewerType.RETURN && commandData !== _ViewMode.LightBoxExitPDFViewerType.CLOSE) {
      err = (0, _ErrorUtils.commandError)(_ApiConstants.default.API_RESPONSE.INVALID_INPUT, `Only "RETURN" or "CLOSE" value is supported for command ${command}`);
    }
    return err;
  }
  _setExitPDFViewerType(data) {
    if (_ServiceRegistry.default.getService("AppStore").isLBPreset) {
      _ServiceRegistry.default.getService("AppStore").configStore.setExitPDFViewerType(data);
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  _openEditMode() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    return appStore.editReadyPromise.then(() => {
      const validationService = _ServiceRegistry.default.getService("ValidationService");
      appStore.executeDropinPromise = new _Deferred.default();
      if (validationService.validateOpenEditConfig()) {
        const executeActionsOpts = {
          opts: {
            context: _AppConstants.default.CONTEXT
          }
        };
        appStore.executeActionOpts = executeActionsOpts.opts;
        _ServiceRegistry.default.getService("DropinService").executeDropin(_AppConstants.default.EDIT_WORKFLOW.DROPIN);
        return new Promise((resolve, reject) => {
          appStore.executeDropinPromise.promise.then(() => {
            (0, _EditUtil.default)(_CallbackTypes.EditEventTypes.EDIT_TRIGGERED, _CallbackTypes.default.EDIT_EVENT_HANDLER);
            resolve(true);
          }).catch(() => reject(false));
        });
      }
      return Promise.resolve(false);
    }).then(result => result);
  }
  _updateEditEnabled({
    editEnabled,
    toolsBoardEnabled
  }) {
    (0, _EditUtil.loadEditServices)();
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const configStore = _ServiceRegistry.default.getService("AppStore").configStore;
    let actionConfig = configStore.getActionConfig("preview");
    actionConfig = _objectSpread(_objectSpread({}, actionConfig), {}, {
      enableEdit: editEnabled
    });
    configStore.setActionConfig("preview", actionConfig);
    // eslint-disable-next-line no-param-reassign
    appStore.setShouldLoadToolsBoardDropin(toolsBoardEnabled);
    appStore.isEditEnabled = editEnabled;
    // eslint-disable-next-line no-param-reassign
    configStore.getConfig().toolsDropinList = [["editpdf", "side-nav"]];
    return Promise.resolve(true);
  }
  _closeEditMode() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    appStore.exitCallbackPromise = new _Deferred.default();
    _ServiceRegistry.default.getService("ToolsBoardService").closeToolsBoard();
    return new Promise(resolve => {
      appStore.exitCallbackPromise.promise.then(() => {
        resolve(true);
      }).catch(() => resolve(false));
    });
  }
  _getToolsboardConfig(data) {
    return Promise.resolve(_ServiceRegistry.default.getService("ToolsBoardService").getToolsBoardConfig(data));
  }

  /**
   * @method
   * @description
   * Show/hides full page loader
   *
   * @return Return promise which resolve true
   */
  _toggleSpinner(value) {
    _ServiceRegistry.default.getService("AppStore").setShowLoader(value);
    return Promise.resolve();
  }

  /**
   * @method
   * @description
   * Restarts file dirty polling
   *
   * @return Return promise which resolve true
   */
  _startPolling() {
    _ServiceRegistry.default.getService("PollingService").startPolling();
    return Promise.resolve();
  }

  /**
   * @method
   * @description
   * Clears undo-redo command stack
   *
   * @return Return promise which resolve true
   */
  _resetCommandStack() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    appStore.previewRef.getApis("INT_COMMANDS", ["commandManager"]).then(apis => {
      apis.commandManager.clearStack();
    });
    return Promise.resolve();
  }

  /**
   * @method
   * @description
   * Resets quick tool selection
   *
   * @return Return promise which resolve true
   */
  _endAnnotationMode() {
    _ServiceRegistry.default.getService("CommentsApi").endAnnotationMode();
    return Promise.resolve();
  }

  /**
   * @method
   * @description
   * Undo last change without adding in stack
   *
   * @return Return promise which resolve true
   */
  _undoLastComment() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    appStore.previewRef.getApis("INT_COMMANDS", ["commandManager"]).then(apis => {
      appStore.preventDirtyPDF = true;
      apis.commandManager.undo();
      setTimeout(() => {
        appStore.preventDirtyPDF = false;
        appStore.setIsDirty(false);
      }, 500);
      _ServiceRegistry.default.getService("CommentsApi").unselectAnnotation();
    });
    return Promise.resolve(true);
  }
}
exports.default = AppCommands;